// store/modules/onboarding.ts
import api from '@/api';
import { Commit } from 'vuex';

interface OnboardingState {
  showModal: boolean;
}

export default {
  namespaced: true,
  state: (): OnboardingState => ({
    showModal: false
  }),
  getters: {
    showModal: (state: OnboardingState) => state.showModal,
  },
  mutations: {
    SET_SHOW_MODAL(state: OnboardingState, payload: boolean) {
      state.showModal = payload;
    },
    RESET_STATE(state: OnboardingState) {
      state.showModal = false;
    }
  },
  actions: {
    async getInfoByAPI({ commit }: { commit: Commit }) {
      try {
        const { status, data: { data } } = await api.checkRadianFilesByUser();
        
        if (status === 200) {
          const { registro_completo } = data;
          commit('SET_SHOW_MODAL', !registro_completo);
        }
      } catch (e) { console.error(e); }
    },
    closeModal({ commit }: { commit: Commit }) {
      commit('SET_SHOW_MODAL', false);
    },
    resetState({ commit }: { commit: Commit }) {
      commit('RESET_STATE');
    }
  }
};
